
import { useState } from "react";
import RequestQuoteModal from "../../../components/feature/RequestQuoteModal";

export default function ComparisonSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Drafting vs. Takeoff:
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Two specialized services with one goal of empowering your day-to-day operations
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-orange-50 to-white p-8 lg:p-10 rounded-2xl border-2 border-orange-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#e18033] rounded-xl">
                <i className="ri-pencil-ruler-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Drafting Services <span className="block text-xl font-normal text-gray-600 mt-1">(The Visual Execution)</span></h3>
            </div>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Translating conceptual designs and redlines into highly organized, dimensional technical drawings.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Visual Documentation</strong>
                  <span className="text-sm text-gray-600">Translating sketches into precise floor plans, elevations, and RCPs.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Spatial Coordination</strong>
                  <span className="text-sm text-gray-600">Layering architectural and MEP elements to detect clashes.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#e18033] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">As-Built Updates</strong>
                  <span className="text-sm text-gray-600">Updating master CAD files to reflect post-construction field changes.</span>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <strong className="text-gray-900 block mb-2">Best For:</strong>
              <p className="text-sm text-gray-600">
                Architects, engineers, and developers needing reliable CAD overflow support to finalize their visual blueprints.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-white p-8 lg:p-10 rounded-2xl border-2 border-orange-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-[#c97029] rounded-xl">
                <i className="ri-calculator-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900">Takeoff Services</h3>
            </div>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Extracting precise, line-item quantities for low voltage infrastructure and devices directly from completed construction blueprints and floor plans.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Quantity Extractions</strong>
                  <span className="text-sm text-gray-600">Accurate counting and measurement of low voltage components including network cabling (Cat6/Cat6A), fiber runs, CCTV cameras, access control devices, wireless access points, cable pathways, racks, and termination hardware.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#c97029] text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <strong className="text-gray-900 block mb-1">Visual Verification</strong>
                  <span className="text-sm text-gray-600">Providing color-coded PDF markups highlighting device locations, cable routes, and measurement paths to clearly validate every quantity extracted.</span>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <strong className="text-gray-900 block mb-2">Best For:</strong>
              <p className="text-sm text-gray-600">
                Low voltage contractors, security integrators, IT infrastructure providers, and general contractors who need reliable material quantities to apply their own pricing and prepare competitive bids.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#e18033] to-[#c97029] p-8 rounded-2xl text-center">
          <h3 className="text-2xl font-bold text-white mb-3">
            Need Both Services?
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Many clients rely on us to first draft their as-built conditions, and then immediately extract the material quantities required for the upcoming remodel.
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Request a Combined Quote
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>

      <RequestQuoteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
